import React, { useEffect, useRef } from "react";

export const GpsGate_Frame = ({url_back, user_back, pass_back }) => {
  const iframeRef = useRef(null);
  const handleGPS = () => {
    const form = document.createElement("form");
    const url = url_back + "/comGpsGate/public/login";

    form.action = url;
    form.method = "POST";
    form.target = "gpsGateIframe";

    const userInput = document.createElement("input");
    userInput.type = "hidden";
    userInput.name = "username";
    userInput.value = user_back;

    const passInput = document.createElement("input");
    passInput.type = "hidden";
    passInput.name = "password";
    passInput.value = pass_back;

    form.appendChild(userInput);
    form.appendChild(passInput);

    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
  };

  return (
    <div className="-mt-2">
      <iframe
  name="gpsGateIframe"
  title="GpsGate Embed"
  src="https://simplefms.io/GpsModelMining/Index.html"
  style={{ width: "100%" }}
  className="h-[97vh] max-h-97vh z-1"
/>
    </div>
  );
};
